import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BuscarSomenteObrasService {
  buscarSomente() {
    const buscarSomente = [
      { id: 1, description: 'Buscar somente obras sem respons\u00E1veis ' },
      { id: 2, description: 'N\u00E3o incluir obras descartadas' },
      // { id: 3, description: 'Mostrar somente novas obras cadastradas' },
    ];
    return of(buscarSomente);
  }
}
